import type { CameraRoute } from '@datum-sdk/scene-format';

/**
 * The Muzdalifah preloader flights, as SDK scene data: the tour, then a
 * flyover of two views across the camp that settles on the rest pose — its
 * last view.
 *
 * Converted once from the legacy `muzdalifaSceneConfig.camera` by
 * `convertLegacyPreloader.ts` (which says what in here is load-bearing); the
 * routes are the source since. Tune them in the SDK editor (`?flight` → Routes →
 * Copy Routes) — the same workflow as `kaabaRoutes.ts` — and
 * `sceneRoutes.test.ts` holds them to what the preloader and the scene need.
 *
 * The turntable rides polar 70.3° against the scene's 70° floor and the exit
 * chord dips far below it: the constraint is armed only once the flights land.
 */
export const MUZDALIFA_CAMERA_ROUTES: CameraRoute[] = [
  {
    id: 'preview-enter',
    waypoints: [
      {
        target: [-0.07, 1.89, 5.05],
        lookAt: [-1.27, 0.17, 0.39],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
      {
        orbit: {
          radius: 5.110185907,
          azimuth: 1.502020901,
          polar: 1.22751087,
        },
        target: [-1.27, 0.17, 0.39],
        lookAt: 'target',
        duration: 500,
        easing: [0.333333333, 0, 0.666666667, 0.333333333],
      },
    ],
  },
  {
    id: 'preview-turntable',
    loop: true,
    waypoints: [
      {
        orbit: {
          radius: 5.110185907,
          azimuth: 3.072817227,
          polar: 1.22751087,
        },
        target: [-1.27, 0.17, 0.39],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 5.110185907,
          azimuth: 4.643613554,
          polar: 1.22751087,
        },
        target: [-1.27, 0.17, 0.39],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 5.110185907,
          azimuth: 6.214409881,
          polar: 1.22751087,
        },
        target: [-1.27, 0.17, 0.39],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 5.110185907,
          azimuth: 7.785206208,
          polar: 1.22751087,
        },
        target: [-1.27, 0.17, 0.39],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
    ],
  },
  {
    id: 'preview-exit',
    waypoints: [
      {
        target: [-7.5, 1.23, 1.38],
        lookAt: [-1.27, 0.17, 0.39],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
    ],
  },
  {
    id: 'preloader-flyover',
    waypoints: [
      {
        duration: 500,
      },
      {
        kind: 'view',
        position: [-1.814, 0.7, -3.036],
        lookAt: [-1.27, 0.17, 0.39],
        duration: 2500,
        easing: [0.333333333, 0, 0.666666667, 0.66668142],
      },
      {
        kind: 'view',
        position: [4.96, 1.23, -0.6],
        lookAt: [-1.27, 0.17, 0.39],
        duration: 2500,
        easing: [0.333333333, 0.333351765, 0.666666667, 1],
      },
    ],
  },
];
